import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { ButtonText, CardContent, Flex, CardDashboard, Icon } from '@percent/lemonade'
import { ChecksSummaryProps } from './ChecksSummary.types'
import { handleClickAsLink } from '@percent/admin-dashboard/common/utility/handleClickAsLink'

export function ChecksSummary({ organizationId }: ChecksSummaryProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleRedirect = (e: unknown, url: string) => {
    handleClickAsLink(url, navigate)(e as any)
  }

  const cardContent = (title: string, url: string) => (
    <CardContent title={title}>
      <Flex justify="flex-end">
        <ButtonText onClick={e => handleRedirect(e, url)}>
          <Flex align="center">
            <Icon name="expand" size={6} />
            {t('typography.goToChecksOverview')}
          </Flex>
        </ButtonText>
      </Flex>
    </CardContent>
  )

  return (
    <CardDashboard title={t('typography.checksSummary')}>
      {cardContent(t('typography.validationSubmission'), `/validation-submissions?organisationId=${organizationId}`)}
      {cardContent(t('typography.agentVerification'), `/agent-verification?query=${organizationId}`)}
    </CardDashboard>
  )
}
